.input {
    margin-bottom: var(--mantine-spacing-xs);
    flex: 3;
    border-radius: 0 var(--mantine-radius-md) var(--mantine-radius-md) 0;
    background-color: "var(--mantine-color-dark-8)";
}
